import Splide from '@splidejs/splide';

export default function () {
	const splideContainer = document.querySelector('.logo-banner-splide');
	if (splideContainer !== null) {
		var splide = new Splide( '.logo-banner-splide', {
			arrows: false,
			pagination: true,
			perPage: 9,
			label: 'Brand Partners',
			gap: '1.5rem',
			perMove: 1,
			autoplay: true,
			drag: true,
			snap: true,
			pauseOnHover: true,
			pauseOnFocus: true,
			keyboard: true,
			center: true,
			reducedMotion: {
				autoplay: 'pause',
			},
			breakpoints: {
				480: {
					perPage: 2,
					gap: '0.5em',
				},
				640: {
					perPage: 3,
				},
				1024: {
					gap: '1rem',
					perPage: 4,
				},
				1280: {
					perPage: 6,
				}
			}
		} );
		if (splide === null) {
			return;
		} else {
			splide.mount();
		}
		const Components = splide.Components;
		splide.on( 'resized', function() {
			const isOverflow = Components.Layout.isOverflow();
			const list       = Components.Elements.list;
			const lastSlide  = Components.Slides.getAt( splide.length - 1 );
		
			if ( lastSlide ) {
				// Toggles `justify-content: center`
				list.style.justifyContent = isOverflow ? '' : 'center';
		
				// Remove the last margin
				if ( ! isOverflow ) {
					lastSlide.slide.style.marginRight = '';
				}
			}
		} );
	}
}

